import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SnackBarService } from '@teammood/shared/ui/snack-bar';
import { LoggerService } from '../../shared/util/logger';
import { TeamMemberService } from '../../team/team-member/team-member.service';
import { TeamForAdminDTO } from './team-for-admin-dto.type';
import { TeamMemberForAdmin } from './team-member-for-admin.type';
import { sortBy } from "lodash";

@Component({
    selector: 'admin-team-member-settings',
    templateUrl: './admin-team-member-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminTeamMemberSettings {

    @Input()
    teamMember: TeamMemberForAdmin;

    @Output()
    onChange: EventEmitter<void> = new EventEmitter();
    
    constructor(
        private _snackBar: SnackBarService, 
        private teamMemberService: TeamMemberService, 
        private logger: LoggerService, 
    ) {}

    copyDBQuery(teamMemberEmail: string) {
        const query =  `{ email : "${teamMemberEmail}" }`
        navigator.clipboard.writeText(query);
        this._snackBar.success(`Copied ${query}`)
    }

    changeActiveInTeam(team: TeamForAdminDTO) {
        this.teamMemberService.toggle(team.id, this.teamMember.id).then(() => {
                this.onChange.next();
            }, (errors) => {
            this.logger.error(errors.data);
        });
    }

    protected readonly sortBy = sortBy;
}